import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { NoticiaModel } from 'src/app/core/models/noticia.model';
import { NoticiaService } from 'src/app/core/services/noticia.service';
import { BaseComponent } from 'src/app/pages/area-privada/components/base/base.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'dum-mostrar-noticia',
  templateUrl: './mostrar-noticia.component.html',
  styleUrls: ['./mostrar-noticia.component.scss']
})
export class MostrarNoticiaComponent extends BaseComponent implements OnInit {

  imageUpload: File = null;
  urlImageUpload: ArrayBuffer;
  noticia: NoticiaModel = new NoticiaModel();

  constructor(
    private noticiasService: NoticiaService,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,

  ) {
    super();
    this.activatedRoute.params.subscribe((params: ParamMap) => {
      if (params[environment.const.id] !== null &&
        params[environment.const.id] !== undefined &&
        params[environment.const.id] !== 'nuevo') {
        this.noticiasService.get(params[environment.const.id])
          .pipe(takeWhile(() => this.alive))
          .subscribe((noticia) => {
            this.noticia = noticia;
            this.getImage();
          });
      } else {
        this.noticia = new NoticiaModel();
      }
    });
  }

  ngOnInit(): void {
  }

  getImage() {
    this.noticiasService.getImage(this.noticia.id)
      .pipe(takeWhile(() => this.alive))
      .subscribe((imagen) => {
        this.getUrlImg(imagen);
      });
  }

  uploadImage(file) {
    if (file.currentFiles.length !== 0) {
      this.imageUpload = file.currentFiles[0];
      this.getUrlImg(this.imageUpload);
    }
  }

  getUrlImg(file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      this.urlImageUpload = reader.result as ArrayBuffer;
    };
    reader.readAsDataURL(file);
  }


}
